import { useContext } from "react";

import { BdsButton } from "@buildertrend/components";

import { BuilderInfoContext } from "helpers/globalContext/BuilderInfoContext";

import {
    BTConfirm,
    BTConfirmContent,
    BTConfirmFooter,
    BTConfirmHeader,
} from "commonComponents/btWrappers/BTConfirm/BTConfirm";

import { type InternalUserFormActions } from "entity/internalUser/InternalUserDetails/InternalUser.api.types";

import "./OrgOwnerRoleConfirm.less";

export interface IOrgOwnerRoleConfirmProps {
    visible: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    userName: string;
    actionBeingPerformed: InternalUserFormActions;
}

export const OrgOwnerRoleConfirm: React.FunctionComponent<IOrgOwnerRoleConfirmProps> = ({
    visible,
    onConfirm,
    onCancel,
    userName,
    actionBeingPerformed,
}) => {
    const builderContext = useContext(BuilderInfoContext);
    const builderName = builderContext?.name ?? "Company";

    return (
        <BTConfirm
            visible={visible}
            removeHeader
            className="OrgOwnerRoleConfirm"
            fitToContent
            removeBodyPadding
        >
            <BTConfirmHeader className="ConfirmHeader">
                Are you sure you want to assign this role?
            </BTConfirmHeader>
            <BTConfirmContent className="ConfirmContent">
                {userName} will be able to access and edit:
                <ul>
                    <li>All entities in Buildertrend</li>
                    <li>{builderName} bank account information</li>
                    <li>{builderName}'s Buildertrend subscription</li>
                </ul>
            </BTConfirmContent>
            <BTConfirmFooter className="ConfirmFooter">
                <BdsButton
                    onClick={onCancel}
                    testid="cancelRoleChange"
                    text="Cancel"
                    displayType="secondary"
                    className="margin-right-xs"
                />
                <BdsButton
                    onClick={onConfirm}
                    testid="confirmRoleChange"
                    text="Confirm"
                    displayType="primary"
                    loading={actionBeingPerformed !== undefined}
                />
            </BTConfirmFooter>
        </BTConfirm>
    );
};

export default OrgOwnerRoleConfirm;
